import { FREE } from 'self-service-api/constants/ProductLevels';
import { getMerchCardsToShow } from '../../constants/merchCards/MerchCardsToShow';
import { useAppSelector } from '../../reducers';
import { SSM0004ExperimentSelector } from '../../utils/experiments/ssm0004';
import { Section } from '../common/SharedComponents';
import { ShadowCardGrid, ShadowColumn, ShadowSuiteStarterCardGrid, StyledCardGrid, StyledCardGridWrapper, SuiteStarterCardGrid, SuiteStarterCardGridWrapper } from './MerchCardSharedComponents';
import SSM0004SuiteTile from './SSM0004SuiteTile';
import SuiteFreeTile from './SuiteFreeTile';
import { SuiteTile } from './SuiteTile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SuiteTiles = ({
  selectedTab,
  isFreeToStarter
}) => {
  const productLevelsToShow = getMerchCardsToShow({
    tab: selectedTab,
    isFreeToStarter
  });
  const {
    isSSM0004Variant
  } = useAppSelector(SSM0004ExperimentSelector);
  const GridComponent = isFreeToStarter ? SuiteStarterCardGrid : StyledCardGrid;
  const ShadowGridComponent = isFreeToStarter ? ShadowSuiteStarterCardGrid : ShadowCardGrid;
  const GridWrapper = isFreeToStarter ? SuiteStarterCardGridWrapper : StyledCardGridWrapper;
  const suiteCardComponents = productLevelsToShow.map((productLevel, index) => {
    const commonStyles = {
      msGridColumn: index + 1,
      // IE
      gridColumnStart: index + 1,
      paddingLeft: 28,
      paddingRight: 28
    };
    if (FREE === productLevel) {
      return /*#__PURE__*/_jsx(SuiteFreeTile, {
        commonStyles: commonStyles,
        isFreeToStarter: isFreeToStarter
      }, productLevel);
    }
    if (isSSM0004Variant) {
      return /*#__PURE__*/_jsx(SSM0004SuiteTile, {
        productLevel: productLevel,
        commonStyles: commonStyles,
        isFreeToStarter: isFreeToStarter
      }, productLevel);
    }
    return /*#__PURE__*/_jsx(SuiteTile, {
      productLevel: productLevel,
      commonStyles: commonStyles,
      isFreeToStarter: isFreeToStarter
    }, productLevel);
  });
  const shadowColumns = productLevelsToShow.map(productLevel => /*#__PURE__*/_jsx(ShadowColumn, {
    isFreeToStarter: isFreeToStarter
  }, `${productLevel}-shadow`));
  return /*#__PURE__*/_jsx(Section, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx("div", {
      className: "flex-column align-center justify-center",
      children: /*#__PURE__*/_jsxs(GridWrapper, {
        columns: productLevelsToShow.length,
        children: [/*#__PURE__*/_jsx(GridComponent, {
          columns: productLevelsToShow.length,
          children: suiteCardComponents
        }), /*#__PURE__*/_jsx(ShadowGridComponent
        // @ts-expect-error columns prop only conditionally expected
        , {
          columns: productLevelsToShow.length,
          "aria-hidden": "true",
          isFreeToStarter: isFreeToStarter,
          children: shadowColumns
        })]
      })
    })
  });
};